$(function () {
  var getCompanyNews = '';
  let gettradeNews = null;
  let getmediaNews = null;

  getCompanyNews = {
    url : API_PATHS.article_list_path+'&type='+ ARTICLE_TYPE.ZD_JITUAN,
    successCallback : function(response) {
      // 根据返回数据，拼接html
      if(response.data != null && response.data.length > 0){
        var companyNewsHTML = '<ul>';
        var  length = response.data.length;
        for(var i=0;i<length;i++){
          var item = response.data[i];
          if(i == 0){
            companyNewsHTML+=`<div class="hotnews clearfix"><div class="pic">
            <a href="newsDatial.html?id=${item.id}&type=${item.type}" title="${item.title}"><img src="${API_ENV+item.picture}"></a></div>
            <div class="text"><a href="newsDatial.html?id=${item.id}&type=${item.type}" title="${item.title}" class="t">${item.title}</a>
            <div class="overflowHidden" style="width:400px">${item.introduction}</div><span>${item.createdTime.slice(0,10)}</span></div></div>`;
          }else{
            companyNewsHTML+=`<li class="clearfix"><a href="newsDatial.html?id=${item.id}&type=${item.type}" title="${item.title}">${item.title}</a><span>${item.createdTime.slice(0,10)}</span></li>`;

          }
        }
        companyNewsHTML += '</ul>';
        $('.companyNews').html(companyNewsHTML);
      }
    },
  };
  gettradeNews = {
    url : API_PATHS.article_list_path+'&type='+ ARTICLE_TYPE.ZD_FENGONGSI,
    successCallback : function(response) {
      // 根据返回数据，拼接html
      if(response.data != null && response.data.length > 0){
        var companyNewsHTML = '<ul>';
        var length = response.data.length;
        for(var i=0;i<length;i++){
          var item = response.data[i];
          if(i == 0){
            // companyNewsHTML+= `<div class="hotnews"> <a href="newsDatial.html?id=${item.id}&type=${item.type}" title="${item.title}" class="t">${item.title}<span>${item.createdTime.slice(0,10)}</span></a> </div>`;
            companyNewsHTML+=`<div class="hotnews clearfix"><div class="pic">
            <a href="newsDatial.html?id=${item.id}&type=${item.type}" title="${item.title}"><img src="${API_ENV+item.picture}"></a></div>
            <div class="text"><a href="newsDatial.html?id=${item.id}&type=${item.type}" title="${item.title}" class="t">${item.title}</a>
            <div class="overflowHidden" style="width:400px">${item.introduction}</div><span>${item.createdTime.slice(0,10)}</span></div></div>`;
          }else{
            companyNewsHTML+=`<li class="clearfix"><a href="newsDatial.html?id=${item.id}&type=${item.type}" title="${item.title}">${item.title}</a><span>${item.createdTime.slice(0,10)}</span></li>`;

          }
        }
        companyNewsHTML += '</ul>';
        $('.tradeNews').html(companyNewsHTML);
      }
    },
  };
  // getmediaNews = {
  //   url : API_PATHS.article_list_path+'&type='+ ARTICLE_TYPE.ZD_XIANGMUBU,
  //   successCallback : function(response) {
  //     // 根据返回数据，拼接html
  //     if(response.data != null && response.data.length > 0){
  //       var companyNewsHTML = '<ul>';
  //       var length = response.data.length;
  //       for(var i=0;i<length;i++){
  //         var item = response.data[i];
  //         if(i == 0){
  //           companyNewsHTML+= `<div class="hotnews"> <a href="newsDatial.html?id=${item.id}&type=${item.type}" title="${item.title}" class="t">${item.title}<span>${item.createdTime.slice(0,10)}</span></a> </div>`;

  //         }else{
  //           companyNewsHTML+=`<li class="clearfix"><a href="newsDatial.html?id=${item.id}&type=${item.type}" title="${item.title}">${item.title}</a><span>${item.createdTime.slice(0,10)}</span></li>`;
  //         }
  //       }
  //       companyNewsHTML += '</ul>';
  //       $('.media').html(companyNewsHTML);
  //     }
  //   },
  // };
  ANZ.Ajax.get(getCompanyNews);
  ANZ.Ajax.get(gettradeNews);
  // ANZ.Ajax.get(getmediaNews);
  $('.about_ry .menu li').hover(function () {
    $(this).addClass('cur').siblings().removeClass('cur');
    if ($(this).index() == 0) {
      $('.about ').show();
      $('.ry').hide();
    } else {
      $('.ry ').show();
      $('.about').hide();
    }
  });
});



//////////////////
// WEBPACK FOOTER
// ./app/js/index.js
// module id = 1
// module chunks = 9